import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Calendar, CreditCard } from 'lucide-react';

export function AgendaPlaceholder() {
    return (
        <Card>
            <CardHeader className="pb-3">
                <CardTitle className="flex items-center gap-2 text-lg">
                    <Calendar className="w-5 h-5" />
                    Mon Agenda
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div className="text-center py-8 text-slate-500 bg-slate-50 rounded-lg">
                    <Calendar className="w-10 h-10 mx-auto mb-3 opacity-50" />
                    <p className="font-medium">Bientot disponible</p>
                    <p className="text-xs mt-1">Connexion Google Calendar</p>
                </div>
            </CardContent>
        </Card>
    );
}

export function BankAccountPlaceholder() {
    return (
        <Card>
            <CardHeader className="pb-3">
                <CardTitle className="flex items-center gap-2 text-lg">
                    <CreditCard className="w-5 h-5" />
                    Compte Bancaire
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div className="text-center py-8 text-slate-500 bg-slate-50 rounded-lg">
                    <CreditCard className="w-10 h-10 mx-auto mb-3 opacity-50" />
                    <p className="font-medium">Bientot disponible</p>
                    <p className="text-xs mt-1">Connexion bancaire a venir</p>
                </div>
            </CardContent>
        </Card>
    );
}
